<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="My Push">
        <el-form class="filter-wrapper" label-width="60px">
          <el-col :span="5">
            <el-form-item label="HCP Name" prop="role" label-width="120px">
              <el-select v-model="seId" placeholder="Please select hcp name" class="month-select" @change="onSearch">
                <el-option v-for="(se, index) in seIdList" :key="index" :label="se.Name" :value="se.SEID">
                  <el-popover placement="right" width="100%" trigger="hover">
                    <div style="max-width: 300px">
                      <div>Name：{{ se.Name }}</div>
                      <div>Province：{{ se.Province }}</div>
                      <div>City：{{ se.City }}</div>
                      <div>Hospital/Institution：{{ se.Hospital }}</div>
                      <div>Department：{{ se.Department }}</div>
                    </div>
                    <div slot="reference">
                      <span class="se-name">{{ se.Name }}</span>
                    </div>
                  </el-popover>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Request Type" label-width="120px">
              <el-select v-model="oneTimeRequest" placeholder="Please select type" class="month-select"
                @change="onSearch">
                <el-option v-for="(item, index) in oneTimeRequestList" :key="index" :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Status">
              <el-select v-model="status" placeholder="Please select type" class="month-select" @change="onSearch">
                <el-option v-for="(item, index) in statusList" :key="index" :label="item.statusdesc"
                  :value="item.status">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-input style="width: 120px;margin:0 10px;" prefix-icon="el-icon-search" placeholder="Search"
            v-model="searchVal" v-debounce="onSearch" clearable @clear="onSearch" />
          <el-button type="primary" icon="el-icon-plus" @click="openCombinePushDialog()"
            v-role="[2, 3, 5, 7, 9, 11, 13]">
            Create Push
          </el-button>
          <!-- <el-button type="primary" icon="el-icon-plus" @click="newPushDialogVisible = true"
            v-role="[2, 3, 5, 7, 9, 11, 13]">
            New Push删
          </el-button> -->
          <!-- <el-button type="primary" icon="el-icon-plus" @click="quickPushDialogVisible = true">
            Quick Push 删
          </el-button> -->
          <el-button v-role="[2, 3, 13]" type="primary" icon="el-icon-plus" @click="handleMeetingPush()">
            Create Meeting Push
          </el-button>
        </el-form>
      </PageHeader>
    </div>

    <el-tabs v-model="activeTab" class="push-module-tabs">
      <el-tab-pane label="My Push" name="list" />
      <el-tab-pane name="progress">
        <span slot="label">
          Batch Progress
          <el-badge v-if="sendingBadgeCount > 0" :value="sendingBadgeCount" class="progress-tab-badge" />
        </span>
      </el-tab-pane>
    </el-tabs>

    <BatchProgressTab v-if="activeTab === 'progress'" @summary="onBatchSummary" />

    <div v-show="activeTab === 'list'" class="table-wrapper">
      <el-table :data="tableData" ref="SeTable" @sort-change="onSortChange" v-loading="tableLoading"
        row-key="MessageHeadID" element-loading-text="Loading...">
        <el-table-column type="expand" width="20px" fixed>
          <template slot-scope="{ row }">
            <expand-for-draft v-if="row.IsBatchPushDraft" :label="nameLabel" :batch-id="row.BatchID"
              :request-info="row.RequestInfo" />
            <expand-for-pushed v-else :label="nameLabel" :row="row" />
          </template>
        </el-table-column>
        <el-table-column prop="No" fixed label="No." sortable="custom" width="80" />
        <el-table-column prop="PushMessage" fixed label="Push Message" sortable="custom" min-width="165">
          <template slot-scope="{ row }">
            <div v-html="row.PushMessage"></div>
          </template>
        </el-table-column>
        <el-table-column prop="PushTypeName" fixed label="Push Type" sortable="custom" width="120" />
        <el-table-column prop="SeName" fixed :label="columnNameLabel" min-width="100" sortable="custom" />
        <el-table-column prop="Types" fixed label="Type" width="80" sortable="Type" v-if="shouldShowColumn" />
        <!-- <el-table-column prop="Type" label="Type" min-width="80" sortable="Type" v-role=[1,2,3,13]>
          <template slot-scope="{ row }">
            {{row.types?row.types.map(item=>item.TypeDesc).join(','):''}}
          </template>
        </el-table-column> -->
        <el-table-column prop="Hits" label="Hits" sortable="custom" />
        <el-table-column prop="LastViewDate" label="Last View Time" width="165" sortable="custom" />
        <el-table-column prop="ItemCount" label="Item" sortable="custom">
          <template slot-scope="{ row, $index }">
            <el-popover placement="bottom" width="400" trigger="hover" v-if="row.ItemCount > 0"
              @show="showItem(row, $index)">
              <el-table :data="row.item" height="200">
                <el-table-column prop="File" label="File"></el-table-column>
                <el-table-column prop="Duration" label="Duration(s)"></el-table-column>
                <el-table-column prop="Hits" label="Hits"></el-table-column>
                <el-table-column prop="Download" label="Download"></el-table-column>
              </el-table>
              <el-tag class="crp-more" slot="reference" type="warning" effect="dark">
                {{ row.ItemCount }}
                <i class="el-icon-arrow-down"></i>
              </el-tag>
            </el-popover>
            <el-tag class="crp-more" slot="reference" type="warning" effect="dark" v-else>
              {{ row.ItemCount }}
              <i class="el-icon-arrow-down"></i>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Adandam" label="Comment" sortable="custom" min-width="140">
          <template slot-scope="{ row }">
            <div class="reduce-adandam" v-html="row.Adandam"></div>
          </template>
        </el-table-column>
        <el-table-column width="90" prop="StatusDesc" label="Status" sortable="custom" />
        <el-table-column label="Pushed Date" min-width="145" prop="SentOn" sortable="custom" align="center" />
        <el-table-column label="Like or Dislike" min-width="145" prop="LikeOrDislike" sortable="custom"
          align="center" />
        <el-table-column label="Focus Area" min-width="145" prop="FocusArea" sortable="custom" align="center" />
        <el-table-column label="Operation" min-width="115" prop="StatusDesc" align="center">
          <template slot-scope="{ row }">
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18" v-if="row.Status === 0">
              <template>
                <OptionMenuItem icon="el-icon-edit" title="Edit" @click="handleEdit(row)"
                  v-role="[2, 3, 5, 7, 9, 11, 13]" />
                <OptionMenuItem icon="el-icon-upload2" title="Submit" @click="handleSubmit(row)" />
                <OptionMenuItem icon="el-icon-delete" title="Delete" v-role="[2, 3, 5, 7, 9, 11, 13]"
                  @click="handleDelete(row)" />
              </template>
            </OptionMenu>
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18" v-if="row.Status === 1">
              <template>
                <OptionMenuItem icon="el-icon-refresh-left" title="Recall" v-role="[2, 3, 5, 7, 9, 11, 13]"
                  @click="handleRecall(row.MessageHeadID)" />
              </template>
            </OptionMenu>
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18" v-if="row.Status === 2 && row.AdandamCount < 3">
              <OptionMenuItem icon="el-icon-plus" title="Add Comment" @click="handleAddAdandam(row)" />
            </OptionMenu>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <div class="actions">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </div>
    <CombinePushDialog :visible.sync="combinePushDialogVisible" @success="onSuccess(true)" :data.sync="rowData" />
    <NewPushDialog :visible.sync="newPushDialogVisible" @success="onSuccess(true)" />
    <EditPushDialog :visible.sync="editPushDialogVisible" :data.sync="rowData" @success="onSuccess" />
    <QuickPushDialog :visible.sync="quickPushDialogVisible" @success="onSuccess(true)" />
    <EditQuickPushDialog :visible.sync="editQuickPushDialogVisible" :data.sync="rowData" @success="onSuccess(true)" />
    <NewMeetingDialog :visible.sync="newMeetingDialogVisible" @success="onSuccess(true)" />
    <EditMeetingDialog :visible.sync="editMeetingDialogVisible" :data.sync="rowData" @success="onSuccess" />
    <AddAdandamDialog :visible.sync="addAdandamDialogVisible" :data.sync="rowData" @success="onSuccess" />
    <!-- 隐藏的富文本预加载实例，加快首次打开弹窗时的加载速度 -->
    <TinymceEditor
      v-if="editorPreloaded"
      v-model="editorPreloadContent"
      :height="0"
      style="position:absolute;left:-9999px;opacity:0;pointer-events:none;"
    />
  </div>
</template>
<script>
import CombinePushDialog from "../combine-push/combine-push-dialog.vue";
import NewPushDialog from "../new-push-dialog";
import EditPushDialog from "../edit-push-dialog";
import QuickPushDialog from "../quick-push-dialog";
import EditQuickPushDialog from "../edit-quick-push-dialog";
import NewMeetingDialog from "../new-meeting-push-dialog";
import EditMeetingDialog from "../edit-meeting-push-dialog";
import AddAdandamDialog from "../add-adandam-dialog";
import { RoleCode } from "@/utils/role-constant";
import ExpandForPushed from "./expand-for-pushed";
import ExpandForDraft from "./expand-for-draft";
import TinymceEditor from "@/components/tinymce-editor.vue";
import BatchProgressTab from "./batch-progress-tab.vue";
export default {
  name: "My-Push",
  components: {
    ExpandForDraft,
    ExpandForPushed,
    NewPushDialog,
    EditPushDialog,
    QuickPushDialog,
    EditQuickPushDialog,
    EditMeetingDialog,
    NewMeetingDialog,
    AddAdandamDialog,
    CombinePushDialog,
    TinymceEditor,
    BatchProgressTab,
  },
  data() {
    return {
      typeLoading: false,
      typeId: '',
      searchVal: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      draft: true,
      pushed: false,
      newPushDialogVisible: false,
      editPushDialogVisible: false,
      quickPushDialogVisible: false,
      editQuickPushDialogVisible: false,
      newMeetingDialogVisible: false,
      editMeetingDialogVisible: false,
      addAdandamDialogVisible: false,
      selectMessageHeadId: "",
      rowData: null,
      orderBy: "",
      orderType: "",
      tableData: [],
      tableLoading: false,
      combinePushDialogVisible: false,
      seIdList: [],
      seId: '',
      oneTimeRequestList: [],
      oneTimeRequest: '',
      statusList: [
        {
          status: '',
          statusdesc: 'All'
        }, {
          status: 0,
          statusdesc: 'Draft'
        }, {
          status: 1,
          statusdesc: 'Submitted'
        }, {
          status: 2,
          statusdesc: 'Pushed'
        }],
      status: '',
      // 用于预加载富文本编辑器，避免首次打开弹窗时白屏等待
      editorPreloadContent: "",
      editorPreloaded: true,
      activeTab: "list",
      sendingBadgeCount: 0,
    };
  },
  filters: {
    pushTypeFilter(value) {
      const list = {
        0: "New Push",
        1: "Quick Push",
        3: "Meeting Push",
      };
      return list[value];
    },
  },
  computed: {
    nameLabel() {
      const role = this.$store.state.role;
      if (role === RoleCode.ML || role === RoleCode.Supervisor) {
        return "SE/CE"
      } else if (role === RoleCode.VMSL) {
        return "vCE"
      } else {
        return "Customer";
      }
    },
    columnNameLabel() {
      // return `${this.nameLabel} Name`;
      return `Name`;
    },
    shouldShowColumn() {
      // Admin, Supervisor, ML, VMSL
      return [1, 2, 3, 13].includes(this.$store.state.role);
    }
  },
  created() {
    this.loadBatchSummary();
    this.getFilterData();
    this.getTableData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getTableData();
        this.getFilterData();
      }
    });
  },
  methods: {
    onBatchSummary(summary) {
      this.sendingBadgeCount = summary && summary.sending ? summary.sending : 0;
    },
    loadBatchSummary() {
      this.axios.get("/batchPush/summary").then(({ code, data }) => {
        if (code === 200) this.sendingBadgeCount = data.sending || 0;
      }).catch(() => {});
    },
    openCombinePushDialog(rowData) {
      this.combinePushDialogVisible = true;
      this.rowData = rowData || null;
    },
    getFilterData() {
      this.axios.get(`/combinePush/seFilter`).then(({ code, data }) => {
        if (200 === code) {
          this.seIdList = data;
          this.seIdList.unshift({
            SEID: '',
            Name: 'All'
          });
        }
      })
      this.axios.get(`/combinePush/param`).then(({ code, data }) => {
        if (200 === code) {
          this.oneTimeRequestList = data.pushType;
          this.oneTimeRequestList.unshift({
            key: '',
            value: 'All'
          });
        }
      })
    },
    showItem(row, index) {
      if (this.tableData[index].item) {
        return;
      }
      this.axios
        .get(`/push/item`, {
          params: { pushType: row.PushType, pushId: row.MessageHeadID },
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.$set(this.tableData, index, {
              item: data,
              ...this.tableData[index],
            });
          } else {
            this.$message.error(msg);
          }
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
        seId: this.seId,
        oneTimeRequest: this.oneTimeRequest,
        status: this.status
      };
      this.axios
        .get(`/combinePush/pushList`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
          } else {
            this.$message.error(msg);
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleMeetingPush(row) {
      this.rowData = row;
      this.newMeetingDialogVisible = true;
    },
    handleEdit(row) {
      this.rowData = row;
      if (row.PushType == 4) {
        this.openCombinePushDialog(row);
      } else {
        if (row.OneTimeRequest === 2) {
          if (row != null) {
            if (row.Status !== 0 && row.Status !== 3) {
              this.$message(
                "Only the meeting on Open/Rescheduled status can be edited!"
              );
              return;
            }
            if (row.ModifyBy === "TransferData") {
              this.$message(
                "Meeting transferred from old system cannot be edited!"
              );
              return;
            }
          }
          this.editMeetingDialogVisible = true;
        } else if (row.OneTimeRequest === 3 || row.OneTimeRequest === 4) {
          this.editQuickPushDialogVisible = true;
        } else {
          this.editPushDialogVisible = true;
        }
      }
    },
    handleSubmit(row) {
      const { BatchID, PushType,MessageHeadID, IsBatchPushDraft } = row;
      this.$confirm("请确认推送给HCP。", "", {
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        type: 'warning'
      }).then(() => {
        if (PushType == '3') {
          let url = "/push/submit";
          let params = {
            messageHeadId: MessageHeadID,
          };
          if (IsBatchPushDraft) {
            url = "/push/submitBatchDraft";
            params = {
              batchId: BatchID,
            };
          }
          this.axios
            .get(url, {params})
            .then(({ code, msg }) => {
              if (code == 200) {
                this.$message.success("Submit successfully");
                this.getTableData();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => { });
        } else if (PushType == '4') {
          let url = "/combinePush/submit";
          let params = {
            batchId: BatchID,
          };
          this.axios
            .get(url, { params })
            .then(({ code, msg, data }) => {
              if (code == 200) {
                this.$message.success(data ? data : "Submit successfully");
                this.getTableData();
                this.getFilterData();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => { });
        }
      });
    },
    handleDelete(row) {
      const { BatchID,MessageHeadID, IsBatchPushDraft,PushType  } = row;
      this.$confirm("Once deleted, it cannot be recovered.", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(() => {
        if (PushType == '3') {
          let url = "/push/delete";
          let data = {
            messageHeadId: MessageHeadID,
          };
          if (IsBatchPushDraft) {
            url = "/push/deleteBatchDraft";
            data = {
              batchId: BatchID,
            };
          }
          this.axios
            .post(url, data)
            .then(({ code, msg }) => {
              if (code == 200) {
                this.$message.success("Delete successfully");
                this.getTableData();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => { });
        } else if (PushType == '4') {
          let url = "/combinePush/delete";
          let data = {
            batchId: BatchID,
          };
          this.axios
            .post(url,data)
            .then(({ code, msg, data }) => {
              if (code == 200) {
                this.$message.success(data ? data : "Delete successfully");
                this.getTableData();
                this.getFilterData();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => { });
        }
      });
    },
    handleRecall(messageHeadId) {
      this.$confirm("Please make sure if it is ready to recall?", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(() => {
        this.axios
          .get("/push/recall", {
            params: {
              messageHeadId: messageHeadId,
            },
          })
          .then(({ code, msg }) => {
            if (code == 200) {
              this.$message.success("Recall successfully");
              this.getTableData();
              this.getFilterData();
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => { });
      });
    },
    handleAddAdandam(row) {
      this.rowData = row;
      this.addAdandamDialogVisible = true;
    },
    onSuccess(resetPage = true) {
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.getTableData();
      this.getFilterData();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-table ::v-deep {

  .el-table__expanded-cell,
  .el-table__expanded-cell:hover {
    background-color: #f9f9f9 !important;
    padding: 20px 30px;
  }
}

.cell {
  .reduce-adandam {
    line-height: 16px;
  }
}



::v-deep {
  .el-select.month-select {
    width: 208px;
    margin-right: 10px;
    height: 28px;
  }

  .el-select.month-select>.el-input {
    height: 28px !important;
  }
}

.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding: 0 !important;

  .el-form-item {

    .el-select {
      width: 100%;
    }
  }

  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}
</style>
